import { Record } from "immutable";
import { EventType } from "models/enumerations/events/event-type";
import { ConversationEvent } from "models/interfaces/events/conversation-event";

const defaultValues: ConversationEvent = {
    type: EventType.ConversationAction,
    sessionId: "",
    conversationEvent: {
        conversationId: "",
        action: "",
    },
};

export default class ConversationEventRecord
    extends Record(defaultValues)
    implements ConversationEvent
{
    constructor(params: Partial<ConversationEvent> = {}) {
        super(params ?? defaultValues);
    }
}
